import request from '../../axios';

const PostEmployeeAdvertisement = async (
  payload: IEmployeeAdvertisementPayload,
): Promise<IAddedAdvertisementResponse> => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    name: payload.name,
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    description: payload?.description || undefined,
    ...(payload.negotiated_price !== true && {ad_price: payload?.ad_price}),
    profile_type: 'supplier',
    type: payload?.type?.value,
    price_unit: payload.price_unit?.value,
    negotiated_price: payload?.negotiated_price || false,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    from_date: payload?.from_date,
    to_date: payload?.to_date,
    exclude_holydays: payload?.exclude_holydays,
    exclude_fridays: payload?.exclude_fridays,
    age: payload?.age,
    hide_phone_number: payload?.hide_phone_number,
    job_experience: payload?.job_experience,
    from_hour: payload?.from_hour?.guid,
    gender: payload?.gender?.guid,
    to_hour: payload?.to_hour?.guid,
    has_discount: payload?.has_discount || undefined,
    discount_amount: payload?.discount_amount || undefined,
    only_massage_buyer: payload.only_massage_buyer || false,
    images_id: payload?.images?.map(item => item).join(','),
    // @ts-ignore
    main_image_id: payload?.main_image?.id,
  };

  const res = await request.post(`api/v2/store/employee-advertisement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostEmployeeAdvertisement;
